/*
 * Description: Display Link Web Component
 * Purpose: Displays a styled anchor link with optional icon
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Configurable href and target
 * - Optional Boxicons icon
 * - External link icon for target="_blank"
 * - Slot-based text content
 *
 * Usage:
 * <display-link href="https://example.com">Visit Site</display-link>
 * <display-link href="https://example.com" target="_blank">External Link</display-link>
 * <display-link href="/about" icon="bx-home">Home</display-link>
 *
 * Attributes:
 * - href: String - The link URL (required)
 * - target: String - Link target: '_self', '_blank' (default: '_self')
 * - icon: String - Boxicons icon class (optional)
 *
 */

class display_link extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) return;

        const href = this.getAttribute('href') || '#';
        const target = this.getAttribute('target') || '_self';
        const icon = this.getAttribute('icon');
        const content = this.innerHTML.trim();

        const iconHtml = icon
            ? `<i class="bx ${icon} me-1"></i>`
            : '';

        const externalIcon = target === '_blank'
            ? `<i class="bx bx-link-external ms-1 small"></i>`
            : '';

        this.innerHTML = `
            <a href="${href}" target="${target}" class="text-decoration-none">
                ${iconHtml}${content}${externalIcon}
            </a>`;

        this.dataset.rendered = "true";
    }
}

export { display_link };
